/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Solid_Crisp_Wren_DelightInputs */

const fr_solid_crisp_wren_delight = /** @type {(inputs: Solid_Crisp_Wren_DelightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refuser`)
};

/**

* @param {Solid_Crisp_Wren_DelightInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const solid_crisp_wren_delight = /** @type {((inputs?: Solid_Crisp_Wren_DelightInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Solid_Crisp_Wren_DelightInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_solid_crisp_wren_delight(inputs)
});